module.exports = __webpack_public_path__ + "img/tertiary_3x4.dd062495.svg";